import * as actionTypes from '../actionTypes/success';
export function getPowers(productId, powerType) {
  return { type: actionTypes.POWERS_DETAIL_LOAD, productId, powerType };
}
export function getSavedPrescription(powerType) {
  return { type: actionTypes.SAVED_PRESCRIPTION_LOAD, powerType };
}
export function submitPowers(itemid, data, userEmail, orderId) {
  return { type: actionTypes.SUBMIT_POWERS_LOAD, itemid, data, userEmail, orderId };
}
export function getSubmittedPowers(itemid, userEmail) {
  return { type: actionTypes.SUBMITTED_POWERS_LOAD, itemid, userEmail };
}
export function getSubmittedOtp(otp, email) {
  return { type: actionTypes.OTP_SUBMISSION_LOAD, otp, email };
}
export function enterErrorFunc(data) {
  return { type: actionTypes.MSG_ERROR, data };
}
export function enterDataFunc(data) {
  return { type: actionTypes.ENTER_DATA, data };
}
export function getStoreSlots(storeCode) {
  return { type: actionTypes.SLOTS_LOAD, storeCode };
}
export function pfuStoreBookAppointment(orderId, itemId, appointmentData) {
  return { type: actionTypes.APPOINTMENT_BOOK_LOAD, orderId, itemId, appointmentData };
}
export function getAppointmnetDetails(appointmentId, source) {
  return { type: actionTypes.GET_APPOINTMENT_DETAILS_LOAD, appointmentId, source };
}
export function cancelPfuAppointment(orderId, itemId, params) {
  return { type: actionTypes.CANCEL_PFU_APPOINTMNET_LOAD, orderId, itemId, params };
}
export function getHecAppointmentDetail(appointmentId) {
  return { type: actionTypes.HEC_APPOINTMNET_LOAD, appointmentId };
}
export function cancelHecAppointmnet(appointmentId, reason) {
  return { type: actionTypes.HEC_CANCEL_LOAD, appointmentId, reason };
}
export function hecDetailJunoUpdate(appointmentId) {
  return { type: actionTypes.HEC_DETAIL_JUNO_UPDATE_LOAD, appointmentId };
}
export function activeFrameData(data, index) {
  return { type: actionTypes.ACTIVE_FRAME_DATA, data, index };
}
export function showPowerDD(data) {
  return { type: actionTypes.SHOW_DD, data };
}
export function updatePackages(itemid, data, orderId) {
  return { type: actionTypes.SUBMIT_PACKAGE_LOAD, itemid, data, orderId };
}
export function uploadCameraPdValue(formData) {
  return { type: actionTypes.PD_CAMERA_UPLOAD_LOAD, formData };
}
export function resetState() {
  return { type: actionTypes.RESET_STATE };
}
